import axios from 'axios'
import Version from './Version'

/**
 * получить версию сборки
 * @return {Version} версия сборки
 */
export async function getVersion() {
  let versionData
  await axios
    .get(`/version.json?timestamp=${new Date().getTime()}`)
    .then((resp) => {
      versionData = resp.data
    })
    .catch((err) => {
      console.error('Could not retrieve build version information')
    })
  if (versionData) {
    return new Version(versionData)
  }
}

/**
 * проверить, что значение является булевым
 * @param {any} value значение
 * @return {Boolean} результат
 */
export function isBoolean(value) {
  return value === true || value === false || toString.call(value) === '[object Boolean]'
}
